import type { Health } from '@shared/domain';

export function fmt(n: number | null | undefined, digits = 1): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return n.toFixed(digits);
}

export function pct(n: number | null | undefined, digits = 0): string {
  if (n === null || n === undefined) return '—';
  return `${n.toFixed(digits)}%`;
}

export function int(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return Math.round(n).toLocaleString('en-US');
}

/** Format an ISO timestamp in the factory timezone (Asia/Shanghai). */
export function ts(iso: string | null | undefined, withSeconds = true): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const opts: Intl.DateTimeFormatOptions = {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  if (withSeconds) opts.second = '2-digit';
  return new Intl.DateTimeFormat('zh-CN', opts).format(d).replace(/\//g, '-');
}

export const HEALTH_LABEL: Record<Health, string> = {
  normal: '正常',
  warning: '预警',
  alarm: '报警',
  offline: '离线',
};

/** Tailwind class triple for a health pill. */
export const HEALTH_STYLE: Record<Health, string> = {
  normal: 'bg-ok-bg text-ok-fg border border-ok-border',
  warning: 'bg-warn-bg text-warn-fg border border-warn-border',
  alarm: 'bg-alarm-bg text-alarm-fg border border-alarm-border',
  offline: 'bg-slate-100 text-slate-500 border border-slate-200',
};

export const LEVEL_LABEL: Record<string, string> = { L1: '一级', L2: '二级', L3: '三级' };
export const LEVEL_STYLE: Record<string, string> = {
  L1: 'bg-alarm-bg text-alarm-fg border border-alarm-border',
  L2: 'bg-warn-bg text-warn-fg border border-warn-border',
  L3: 'bg-info-bg text-info-fg border border-info-border',
};
